export function getFileExtension(fileName) {
    return fileName.slice(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase();
}
